import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { tap, finalize } from "rxjs/operators";
import { WorkOrderWithAssignments, WorkOrderStatus, WorkOrderType } from "../../../models/work-order.model";
import { WorkOrderService } from "../../../services/work-order.service";
import { LoaderService } from "../../../services/loader.service";
import { Contact } from "../../../../admin/models/contact.model";
import { SubHeader } from "../../../../core/models/sub-header.model";
import { SubHeaderService } from "../../../../core/services/sub-header.service";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../../../core/models/dialog.model";


@Component({
    selector: "work-order-detail",
    templateUrl: "./work-order-detail.component.html",
    styleUrls: ["./work-order-detail.component.scss"],
    standalone: false
})
export class WorkOrderDetailComponent implements OnInit, OnDestroy {
    @Input() selectedItem: WorkOrderWithAssignments;
    @Input() standAlone: boolean = true;
    @Output() completed = new EventEmitter<WorkOrderWithAssignments>();

    subscription = new Subscription();

    successDialog = new Dialog("Task has been completed.", [new DialogButton("OK", true, () => this.onDialogConfirm())])
    failDialog = new Dialog("An error has occurred in completing the task.", [new DialogButton("OK", true, () => this.onDialogConfirm())]);

    get isAdhoc(): boolean {
        return this.selectedItem && this.selectedItem.type === WorkOrderType.AdHoc;
    }

    get isComplete(): boolean {
        return this.selectedItem && this.selectedItem.status === WorkOrderStatus.Completed;
    }

    get workOrderCreator(): Contact {        
        if (this.selectedItem && this.selectedItem.creator) {
            return this.selectedItem.creator;
        }
        const contact = new Contact();
        contact.firstName = "System";
        contact.lastName = "";
        return contact;
    }

    constructor(private readonly service: WorkOrderService, private readonly router: Router, private readonly route: ActivatedRoute, private loader: LoaderService,
        private readonly subheader: SubHeaderService, private dialogService: DynamicDialogService) { }

    ngOnInit() {
        if (this.standAlone) {
            const routeObs$ = this.route.data.pipe(
                tap((data) => {
                    this.selectedItem = data.workOrder;
                    const subHeader = new SubHeader({ title: `Work Order Details: ${this.selectedItem.title}` });
                    this.subheader.updateSubHeader(subHeader);
                }),
                finalize(() => { this.subscription.add(routeObs$); })).subscribe(() => { console.log("form ready"); }, (error) => { console.error(error); });
            const completedObs$ = this.completed.pipe(tap(() => {
                this.loader.toggleLoader(false);
                
            }), finalize(() => { this.subscription.add(completedObs$); })).subscribe(() => { }, (error) => { console.error(error); });
        }     
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    markComplete(): void {
        this.loader.toggleLoader(true);
        const chgObs$ = this.service.changeStatus(this.selectedItem.id, WorkOrderStatus.Completed).pipe(
            tap(() => {
                this.selectedItem.status = WorkOrderStatus.Completed;                
                this.completed.emit(this.selectedItem);
            }),
            finalize(() => { this.subscription.add(chgObs$); })).subscribe(() => {
                this.loader.toggleLoader(false);
                this.successDialog.message = `Task ${this.selectedItem.title} has been completed.`;
                this.successDialog.toggleDialog(true);
                this.dialogService.updateDialog(this.successDialog);
                
            },
            (error) => {
                console.error(error);
                this.loader.toggleLoader(false);
                this.failDialog.toggleDialog(true);
                this.dialogService.updateDialog(this.failDialog);
            });        
    }

    onDialogConfirm(): void {
        if (this.standAlone) {
            this.router.navigate(["/home"]);
        }        
    }
}
